{
	const $navbars    = document.getElementsByClassName(`navbar-sticky-clone`) as HTMLCollectionOf<HTMLDivElement>,
	      $buttons    = document.getElementsByClassName(`navbar-menu-button`) as HTMLCollectionOf<HTMLDivElement>,
	      intersector = new IntersectionObserver(
		      entries => requestAnimationFrame(() => {

			      for (const $button of $buttons) {
				      $button.classList.remove(`active`);
			      }

			      for (let entry of entries) {
				      if (!(entry.target instanceof HTMLElement)) return;
				      for (const $navbar of $navbars) {
					      if (entry.isIntersecting) $navbar.classList.remove(`is-stuck`);
					      else $navbar.classList.add(`is-stuck`);
				      }

			      }
		      }), {
			      threshold: 0
		      });

	document.querySelectorAll<HTMLDivElement>(`.navbar-sticky`).forEach($navbar => {
		const $clone = $navbar.cloneNode(true) as HTMLDivElement;
		$clone.classList.add(`navbar-sticky-clone`);
		document.body.insertAdjacentElement(`beforeend`, $clone);
		intersector.observe($navbar);
	});

	document.body.addEventListener(`click`, e => {
		if (!(e.target instanceof HTMLElement)) return;

		for (const $button of $buttons) {
			if (e.target === $button) e.target.classList.toggle(`active`);
			else $button.classList.remove(`active`);
		}

	}, {passive: true, capture: false});
}